/**
 * Created for Plausible analytics tracking context
 */
import { createContext, useContext } from 'react';

export type PlausibleTrackingProperties = Record<string, string>;

export type PlausibleContextType = {
  trackingProperties: PlausibleTrackingProperties | null;
  trackPlausible: (event: string, extra?: Record<string, string>) => void;
};

export const PlausibleContext = createContext<PlausibleContextType>({
  trackingProperties: null,
  trackPlausible: () => {},
});

export const PlausibleProvider = PlausibleContext.Provider;

export function usePlausible(): PlausibleContextType {
  return useContext(PlausibleContext);
}
